/** Blank template for new Sacred Library topics (KV publish). */

const DEEP_TEMPLATE = {
  tattva: "",
  iconography: [],
  stories: [],
  mantras: [],
  stotras: [],
  puja_vidhi: [],
  sadhana_guide: [],
  do_and_dont: [],
  charity: [],
  temples: [],
  scriptural_refs: [],
  astrological_notes: [],
};

export function createEmptySacredEntry(type, id) {
  const slug = id.replace(/_/g, " ");
  const titleCase = slug.replace(/\b\w/g, (c) => c.toUpperCase());

  if (type === "deity") {
    return {
      id,
      name: titleCase,
      beginner: {
        identity: "",
        meaning: "",
        why_it_matters: "",
        key_mantra: "",
        short_story: "",
        simple_sadhana: "",
      },
      deep: { ...DEEP_TEMPLATE },
      deity_ids: [],
    };
  }
  if (type === "festival") {
    return {
      id,
      name: titleCase,
      beginner: {
        meaning: "",
        why_celebrated: "",
        key_mantra: "",
        simple_puja: "",
      },
      deep: { ...DEEP_TEMPLATE },
      deity_ids: [],
      festival_ids: [],
    };
  }
  if (type === "vrata") {
    return {
      id,
      name: titleCase,
      beginner: {
        meaning: "",
        key_mantra: "",
        simple_rules: [],
      },
      deep: { ...DEEP_TEMPLATE },
      vrata_ids: [],
      deity_ids: [],
    };
  }
  if (type === "story") {
    return {
      id,
      title: titleCase,
      beginner: { summary: "", moral: "" },
      deep: { ...DEEP_TEMPLATE, full_story: "" },
      story_ids: [],
      deity_ids: [],
    };
  }
  if (type === "sadhana") {
    return {
      id,
      name: titleCase,
      beginner: { purpose: "", mantra: "", steps: [] },
      deep: { ...DEEP_TEMPLATE },
      sadhana_ids: [],
      deity_ids: [],
    };
  }
  return { id, name: titleCase, beginner: {}, deep: { ...DEEP_TEMPLATE } };
}

export function deepLayerTemplate(type) {
  const base = { ...DEEP_TEMPLATE };
  if (type === "story") return { ...base, full_story: "" };
  return base;
}
